import { useLazyQuery } from "@apollo/client/react";
import { useEffect, useState } from "react";
import moment from "moment";

import { CONTRATOS_VIGENTES } from '../../../data/graphQL/queries/MisVisitas/getContratosVigentes';
import toast from "react-hot-toast";
import { normalizeFilterValue } from '../../../helpers/tools';
import { mesesEnum } from "../constants";

const ESTADO_EN_CURSO_ID = "En curso";

export const useGetRows = (filters) => {
  const [rows, setRows] = useState([]);
  const [datosOriginales, setDatosOriginales] = useState([]);

  const [getContratos, { data: dataContratos, loading }] = useLazyQuery(CONTRATOS_VIGENTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataContratos) return;
    setRows(dataContratos?.contratosVigentes);
    setDatosOriginales(dataContratos?.contratosVigentes);
  }, [dataContratos]);

  const handleSearch = () => {
    getContratos({
      variables: {
        input: {
          filtraPorPaciente: filters?.tipoVisita === 2,
          idPaciente: parseInt(filters?.idPaciente?.id) || null,
          idDelegacion: Number(filters?.idDelegacion) || null,
          mes: filters?.mes || null,
          anio: filters?.anio || null
        }
      }
    });
  };

  const applyTextFilter = () => {
    const inputBuscar = filters?.textInput.trim().toUpperCase();

    if (!inputBuscar || inputBuscar.length < 2) {
      return datosOriginales;
    }

    const dataFiltered = datosOriginales?.filter((row) => {
      return ['programa', 'idEvaluacion', 'idPaciente', 'paciente', 'estado'].some((fieldName) => {
        const value = normalizeFilterValue(row[fieldName]);
        return value.includes(inputBuscar);
      });
    });

    return dataFiltered;
  };

  const esFiltroEnPasado = () => {
    if (normalizeFilterValue(filters?.estado) !== normalizeFilterValue(ESTADO_EN_CURSO_ID)) {
      return false;
    }

    const mesEncontrado = mesesEnum.find(m => m.code === filters?.mes?.toUpperCase());
    if (!mesEncontrado || !filters?.anio) return false;

    const fechaFiltro = moment(`${filters.anio}-${mesEncontrado.value}-01`, "YYYY-M-D");
    const hoy = moment();

    // Compara solo por mes
    return fechaFiltro.isBefore(hoy, 'month');
  };

  const applyClientSideFilters = () => {
    if (filters?.tipoVisita !== 2) {
      // Si el filtro es "En curso" y está en el pasado, no mostrar nada
      if (esFiltroEnPasado()) {
        setRows([]);
        return;
      }

      const dataFilteredByText = applyTextFilter();

      const dataFilteredByEstado = dataFilteredByText?.filter((row) => {
        return normalizeFilterValue(row.estado) === normalizeFilterValue(filters?.estado);
      });

      setRows(dataFilteredByEstado);
    }
  };

  useEffect(() => {
    if (filters?.tipoVisita === 2 && (isNaN(filters.idDelegacion) || !filters.idDelegacion)) {
      setRows([]);
      toast.error('Por favor, selecciona una delegacion.');
    }
    else if (filters?.tipoVisita === 2 && !filters?.idPaciente) {
      setRows([]);
      toast.error('Por favor, selecciona un paciente válido.');
    } else
      handleSearch();
  }, [filters]);

  useEffect(() => {
    applyClientSideFilters();
  }, [datosOriginales, filters?.textInput, filters?.estado]);

  return {
    rows,
    setRows,
    loading,
    totalCount: rows.length || 0,
    handleSearch
  };
};